import { useIsAuthenticated } from 'mf_core/auth';
import { useApiGet, useApiQuery } from 'mf_core/query';
import { useQuery } from '@tanstack/react-query';

export function useReusableCookieDisclaimerV2(locale: string) {
  return useApiQuery<ReusableContent>(
    `/cms/v1/reusable-contents?title=Cookie Disclaimer&locale=${locale}`
  );
}

//workaround for loggedout mode
export function useReusableCookieDisclaimer(
  locale: string,
  isEnabled: boolean
) {
  const isAuthenticated = useIsAuthenticated();
  const apiGet = useApiGet<ReusableContent>();
  const route = `/${
    isAuthenticated ? 'cms' : 'cms-noauth'
  }/v1/reusable-contents?title=Cookie Disclaimer&locale=${locale}`;
  const enabled = isEnabled;

  return useQuery({
    enabled: enabled,
    queryFn: () => apiGet(route),
    queryKey: [route],
  });
}

export function useReusableContents({
  resellerProspect,
  strTitle,
}: ReusableContentTO) {
  const params: ReusableContentRequest = {
    title: strTitle,
  };
  return useApiQuery<ReusableContent>('/cms/v1/reusable-contents', params, {
    enabled: !resellerProspect,
  });
}

export type ReusableContent = {
  reusableContents: Content[];
  total: number;
};
export type Content = {
  content: string;
  documentModifiedWhen?: string;
  title: string;
};
type ReusableContentRequest = {
  title: string;
};

export type ReusableContentTO = {
  resellerProspect: boolean;
  strTitle: string;
};
